import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import CalculationField from "@components/Calculator/CalculationField/calculationField.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

type Props = {
    setCalculationValue: any;
    cementplateLength: any;
    cementplateWidth: any;
    cementplateThickness: any;
};

const Calculation = ({
    setCalculationValue,
    cementplateLength,
    cementplateWidth,
    cementplateThickness,
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col>
                    <h3 className="d-sm-block">
                        {t(
                            "calculator.cementplateCalculator.cementplateMeasurements",
                        )}
                    </h3>
                </Col>
            </Row>
            <Row>
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateLength"}
                    dimension={"length"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    {...(cementplateLength && { value: cementplateLength })}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateWidth"}
                    dimension={"width"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    {...(cementplateWidth && { value: cementplateWidth })}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementplateThickness"}
                    dimension={"thickness"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(cementplateThickness && {
                        value: cementplateThickness,
                    })}
                />
            </Row>
        </div>
    );
};

export default Calculation;
